"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NSimulationWindowDTOConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NSimulationWindowDTOConverter, _NotificationDocConve);

  function NSimulationWindowDTOConverter() {
    _classCallCheck(this, NSimulationWindowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NSimulationWindowDTOConverter).apply(this, arguments));
  }

  return NSimulationWindowDTOConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NSimulationWindowDTOConverter = NSimulationWindowDTOConverter;